export function Illustrations404() {
  return (
    <svg viewBox="0 0 672.532 738.394">
      <path
        className="fill-ribbon-500 dark:fill-ribbon-300"
        d="M467 149.804c-46.62-7.44-99.71-11.41-155-11.41-50.6 0-99.35 3.32-142.98 9.58.01-.67.02-1.34.05-2.01a149 149 0 01297.91 1.82c.01.68.02 1.35.02 2.02z"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M337.55 1.341A149.047 149.047 0 00168.62 144.57c-.031.67-.04 1.34-.05 2.01 12.961-1.86 26.384-3.454 40.164-4.784A149.022 149.022 0 01337.55 1.34z"
        opacity="0.1"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M532.18 161.624a600.121 600.121 0 00-65.2-13.84 943.364 943.364 0 00-108.74-10.45 1133.608 1133.608 0 00-83.01-.34 973.29 973.29 0 00-106.16 8.97 624.292 624.292 0 00-77.25 15.66C32.61 177.994 0 199.934 0 223.394s32.61 45.4 91.82 61.77c41.64 11.52 92.98 19.37 148.92 22.97 23.09 1.5 46.96 2.26 71.26 2.26 24.38 0 48.33-.77 71.49-2.27 50.91-3.29 98.01-10.1 137.43-20 .21-.06.41-.11.62-.16 2.66-.66 5.28-1.35 7.87-2.04.93-.26 1.85-.51 2.77-.76a.978.978 0 01.16-.05c.88-.24 1.75-.49 2.62-.73 1.74-.5 3.46-.99 5.15-1.5.08-.02.15-.04.22-.06 1.47-.44 2.91-.88 4.34-1.32 1.17-.37 2.33-.73 3.48-1.1q1.26-.405 2.49-.81c.6-.2 1.19-.39 1.77-.59.79-.26 1.58-.53 2.36-.8.33-.11.66-.22.98-.34.75-.25 1.48-.51 2.21-.77.79-.28 1.58-.57 2.36-.85.65-.23 1.3-.47 1.94-.71.54-.21 1.07-.41 1.61-.61 1.47-.55 2.91-1.12 4.33-1.68.71-.29 1.42-.57 2.12-.86.69-.28 1.39-.57 2.07-.86q1.68-.705 3.3-1.41c.52-.24 1.05-.47 1.56-.69.39-.18.77-.35 1.16-.53.28-.12.56-.25.83-.38 1.01-.46 2.01-.93 2.99-1.4q5.64-2.7 10.53-5.52c20.45-11.71 31.24-24.7 31.24-38.2 0-23.46-32.61-45.4-91.82-61.77zm-.54 121.62c-41.69 11.53-93.17 19.38-149.26 22.95-22.81 1.45-46.39 2.2-70.38 2.2-23.91 0-47.41-.74-70.15-2.19-56.18-3.56-107.74-11.41-149.49-22.96C34.09 267.124 2 245.874 2 223.394a24.118 24.118 0 01.74-5.89c5.1-20.28 36.47-39.26 89.62-53.96a623.806 623.806 0 0176.66-15.57 976.027 976.027 0 01106.8-9q17.88-.585 36.18-.58c15.41 0 30.65.31 45.63.91a941.367 941.367 0 01109.37 10.5 598.858 598.858 0 0164.64 13.74c53.14 14.7 84.5 33.67 89.61 53.94a23.822 23.822 0 01.75 5.91c0 22.48-32.09 43.73-90.36 59.85z"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M623.43 224.304c0 13.36-11.01 26-30.67 37.29-3.27 1.88-6.79 3.72-10.53 5.52-.98.47-1.98.94-2.99 1.4-.27.13-.55.26-.83.38-.39.18-.77.35-1.16.53-.51.22-1.04.45-1.56.69q-1.62.705-3.3 1.41c-.68.29-1.38.58-2.07.86-.7.29-1.41.57-2.12.86-1.42.56-2.86 1.13-4.33 1.68-.54.2-1.07.4-1.61.61-.64.24-1.29.48-1.94.71-.78.28-1.57.57-2.36.85-.73.26-1.46.52-2.21.77-.32.12-.65.23-.98.34-.78.27-1.57.54-2.36.8-.58.2-1.17.39-1.77.59q-1.23.405-2.49.81c-1.15.37-2.31.73-3.48 1.1-1.43.44-2.87.88-4.34 1.32-.07.02-.14.04-.22.06-1.69.51-3.41 1-5.15 1.5-.87.24-1.74.49-2.62.73a.978.978 0 00-.16.05c-.92.25-1.84.5-2.77.76-2.58.68-5.21 1.37-7.87 2.04-.21.05-.41.1-.62.16-38.35 9.58-85.4 16.56-137.47 19.93-22.81 1.47-46.59 2.25-71.02 2.25-24.65 0-48.63-.79-71.62-2.29-137.24-8.95-239.38-43.03-239.38-83.71a25.072 25.072 0 011.12-7.3c.06.17.12.33.19.5 14.27 37.48 115.54 67.77 246.94 75.16 20.13 1.14 40.98 1.73 62.32 1.73 21.43 0 42.36-.6 62.57-1.74 131.29-7.42 232.46-37.72 246.68-75.17q.36-.9.63-1.8a25.305 25.305 0 011.55 8.62zM91.67 213.54c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217S126 196.687 126 203.323s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S124 207.21 124 203.323s-13.278-8.217-32.33-8.217z"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M162.67 260.54c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217c16.643 0 34.331 3.581 34.331 10.217s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S195 254.21 195 250.323s-13.278-8.217-32.33-8.217zM531.67 213.54c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217c16.643 0 34.331 3.581 34.331 10.217s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S564 207.21 564 203.323s-13.278-8.217-32.33-8.217zM460.67 260.54c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217c16.643 0 34.331 3.581 34.331 10.217s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S493 254.21 493 250.323s-13.278-8.217-32.33-8.217zM311.67 282.54c-16.643 0-34.331-3.58-34.331-10.217s17.688-10.217 34.33-10.217c16.643 0 34.331 3.581 34.331 10.217s-17.688 10.217-34.33 10.217zm0-18.434c-19.054 0-32.331 4.331-32.331 8.217s13.277 8.217 32.33 8.217S344 276.21 344 272.323s-13.278-8.217-32.33-8.217z"
      />
      <circle cx="336.978" cy="450.704" r="42.012" className="fill-zodiac-500 dark:fill-zodiac-300" />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M565.937 563.554H588.8050000000001V576.317H565.937z"
        transform="rotate(-26.601 274.6 1087.35)"
      />
      <ellipse
        cx="563.82"
        cy="573.748"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="3.989"
        ry="10.636"
        transform="rotate(-56.601 356.921 778.245)"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M617.672 558.502H630.4350000000001V581.37H617.672z"
        transform="rotate(-63.399 426.77 743.05)"
      />
      <ellipse
        cx="637.604"
        cy="573.748"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="10.636"
        ry="3.989"
        transform="rotate(-33.399 371.066 972.9)"
      />
      <circle cx="334.037" cy="440.428" r="14.359" fill="#fff" />
      <ellipse cx="597.87" cy="515.084" fill="#3f3d56" rx="4.766" ry="4.8" transform="rotate(-45 368.465 793.038)" />
      <path
        className="fill-ribbon-500 dark:fill-ribbon-300"
        d="M370.12 405c.632-15.554-12.773-28.728-29.941-29.426s-31.597 11.346-32.229 26.9 11.302 19.087 28.47 19.785 33.068-1.706 33.7-17.26z"
      />
      <ellipse
        cx="644.388"
        cy="537.568"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="6.594"
        ry="21.006"
        transform="rotate(-40.645 403.434 853.218)"
      />
      <ellipse
        cx="557.154"
        cy="537.568"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="21.006"
        ry="6.594"
        transform="rotate(-49.355 337.356 784.164)"
      />
      <path
        fill="#fff"
        d="M348.517 467.26a9.572 9.572 0 01-18.836 3.43l-.003-.019c-.942-5.202 3.08-7.043 8.282-7.985s9.615-.627 10.557 4.575z"
      />
      <path
        fill="#ccc"
        d="M266 495.394a2 2 0 01-2-2v-118a2 2 0 014 0v118a2 2 0 01-2 2zM236 601.394a2 2 0 01-2-2v-86a2 2 0 114 0v86a2 2 0 01-2 2zM313 530.394a2 2 0 01-2-2v-118a2 2 0 114 0v118a2 2 0 01-2 2zM284 615.394a2 2 0 01-2-2v-48a2 2 0 114 0v48a2 2 0 01-2 2zM325 369.394a2 2 0 01-2-2v-48a2 2 0 014 0v48a2 2 0 01-2 2zM225 390.394a2 2 0 01-2-2v-48a2 2 0 014 0v48a2 2 0 01-2 2zM399 395.394a2 2 0 01-2-2v-48a2 2 0 114 0v48a2 2 0 01-2 2zM395 545.394a2 2 0 01-2-2v-58a2 2 0 114 0v58a2 2 0 01-2 2zM355 596.394a2 2 0 01-2-2v-86a2 2 0 114 0v86a2 2 0 01-2 2zM363 449.394a2 2 0 01-2-2v-118a2 2 0 114 0v118a2 2 0 01-2 2z"
      />
      <ellipse
        cx="858.104"
        cy="764.783"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="6.76"
        ry="21.534"
        transform="rotate(-39.938 615.048 1087.291)"
      />
      <circle
        cx="812.297"
        cy="757.305"
        r="43.067"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        transform="rotate(-71.565 624.375 899.86)"
      />
      <path className="fill-zodiac-500 dark:fill-zodiac-300" d="M553.707 710.302H566.7909999999999V733.744H553.707z" />
      <path className="fill-zodiac-500 dark:fill-zodiac-300" d="M527.54 710.302H540.6239999999999V733.744H527.54z" />
      <ellipse cx="555.888" cy="734.016" className="fill-zodiac-500 dark:fill-zodiac-300" rx="10.903" ry="4.089" />
      <ellipse cx="529.72" cy="733.471" className="fill-zodiac-500 dark:fill-zodiac-300" rx="10.903" ry="4.089" />
      <path
        fill="#ccc"
        d="M535.04 622.366c3.845-15.487 20.82-24.601 37.914-20.357s27.834 20.24 23.989 35.728-16.604 15.537-33.698 11.292-32.051-11.176-28.206-26.663z"
      />
      <ellipse
        cx="763.788"
        cy="737.322"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="6.76"
        ry="21.534"
        transform="rotate(-64.626 568.044 905.41)"
      />
      <circle cx="542.124" cy="667.415" r="14.359" fill="#fff" />
      <circle cx="536.222" cy="662.268" r="4.786" fill="#3f3d56" />
      <circle cx="542" cy="697.394" r="6" fill="#fff" />
      <path fill="#3f3d56" d="M671.532 738.394h-236a1 1 0 010-2h236a1 1 0 010 2z" />
    </svg>
  );
}

export function Illustration500() {
  return (
    <svg viewBox="0 0 1119.609 699">
      <circle cx="292.609" cy="213" r="213" fill="#f2f2f2" />
      <path className="fill-zodiac-500 dark:fill-zodiac-300" d="M0 51.142c0 77.498 48.618 140.209 108.7 140.209" />
      <path
        className="fill-ribbon-500 dark:fill-ribbon-300"
        d="M108.7 191.35c0-78.368 54.256-141.783 121.304-141.783M39.384 58.168c0 73.614 31.003 133.183 69.317 133.183"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M108.7 191.35c0-100.137 62.711-181.167 140.209-181.167"
      />
      <path
        fill="#a8a8a8"
        d="M85.833 192.339s15.415-.475 20.061-3.783 23.713-7.258 24.866-1.953 23.167 26.388 5.762 26.529-40.439-2.711-45.076-5.536-5.613-15.257-5.613-15.257z"
      />
      <path
        d="M136.833 211.285c-17.404.14-40.44-2.711-45.076-5.536-3.531-2.15-4.939-9.869-5.41-13.43-.325.014-.514.02-.514.02s.976 12.433 5.613 15.257 27.672 5.676 45.077 5.536c5.023-.04 6.759-1.828 6.663-4.476-.698 1.6-2.614 2.599-6.353 2.629z"
        opacity="0.2"
      />
      <ellipse cx="198.609" cy="424.5" fill="#3f3d56" rx="187" ry="25.44" />
      <ellipse cx="198.609" cy="424.5" opacity="0.1" rx="157" ry="21.359" />
      <ellipse cx="836.609" cy="660.5" fill="#3f3d56" rx="283" ry="38.5" />
      <ellipse cx="310.609" cy="645.5" fill="#3f3d56" rx="170" ry="23.127" />
      <path
        fill="none"
        className="stroke-zodiac-500 dark:stroke-zodiac-300"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M462.61 626c90 23 263-30 282-90M309.61 259s130-36 138 80-107 149-17 172M184.011 537.283s39.073-10.82 41.477 24.045-32.16 44.783-5.11 51.695"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M778.705 563.24l-7.878 50.295s-38.782 20.603-11.513 21.209 155.733 0 155.733 0 24.845 0-14.543-21.815l-7.878-52.719z"
      />
      <path
        d="M753.828 634.198c6.193-5.51 17-11.252 17-11.252l7.877-50.295 113.921.107 7.878 49.582c9.185 5.087 14.875 8.987 18.203 11.978 5.06-1.154 10.588-5.443-18.203-21.389l-7.878-52.719-113.921 3.03-7.878 50.295s-32.588 17.315-16.999 20.663z"
        opacity="0.1"
      />
      <rect
        width="513.253"
        height="357.52"
        x="578.433"
        y="212.689"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="18.046"
      />
      <path fill="#3f3d56" d="M595.703 231.777H1074.416V499.614H595.703z" />
      <circle cx="835.059" cy="223.293" r="3.03" fill="#f2f2f2" />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M1091.686 520.822v31.34a18.043 18.043 0 01-18.046 18.046H596.48a18.043 18.043 0 01-18.046-18.045v-31.34z"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M968.978 667.466L968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 651.452 645.651 962.312 645.651 968.978 667.466z"
      />
      <path
        className="fill-zodiac-500 dark:fill-zodiac-300"
        d="M1094.437 661.534c-.594 2.539-2.836 5.217-7.902 7.75-18.179 9.09-55.143-2.424-55.143-2.424s-28.48-4.848-28.48-17.573a22.725 22.725 0 012.497-1.485c7.643-4.043 32.984-14.02 77.917.423a18.74 18.74 0 018.541 5.597c1.821 2.132 3.249 4.835 2.57 7.712z"
      />
      <path
        d="M1094.437 661.534c-22.25 8.526-42.084 9.162-62.439-4.975-10.265-7.127-19.59-8.89-26.59-8.757 7.644-4.043 32.985-14.02 77.918.423a18.74 18.74 0 018.541 5.597c1.821 2.132 3.249 4.835 2.57 7.712z"
        opacity="0.1"
      />
      <ellipse cx="1066.538" cy="654.135" fill="#f2f2f2" rx="7.878" ry="2.424" />
      <circle cx="835.059" cy="545.667" r="11.513" fill="#f2f2f2" />
      <path
        d="M968.978 667.466L968.978 673.526 642.968 673.526 642.968 668.678 643.417 667.466 968.978 667.466z"
        opacity="0.1"
      />
      <path className="fill-zodiac-500 dark:fill-zodiac-300" d="M108.609 159H316.609V401H108.609z" />
      <path fill="#3f3d56" d="M87.609 135H337.609V221H87.609z" />
      <path fill="#3f3d56" d="M87.609 237H337.609V323H87.609z" />
      <path fill="#3f3d56" d="M87.609 339H337.609V425H87.609z" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M271.609 150H287.609V166H271.609z" opacity="0.4" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M294.609 150H310.609V166H294.609z" opacity="0.8" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M317.609 150H333.609V166H317.609z" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M271.609 251H287.609V267H271.609z" opacity="0.4" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M294.609 251H310.609V267H294.609z" opacity="0.8" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M317.609 251H333.609V267H317.609z" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M271.609 352H287.609V368H271.609z" opacity="0.4" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M294.609 352H310.609V368H294.609z" opacity="0.8" />
      <path className="fill-ribbon-500 dark:fill-ribbon-300" d="M317.609 352H333.609V368H317.609z" />
      <circle cx="316.609" cy="538" r="79" className="fill-zodiac-500 dark:fill-zodiac-300" />
      <path className="fill-zodiac-500 dark:fill-zodiac-300" d="M280.609 600H304.609V643H280.609z" />
      <path className="fill-zodiac-500 dark:fill-zodiac-300" d="M328.609 600H352.609V643H328.609z" />
      <ellipse cx="300.609" cy="643.5" className="fill-zodiac-500 dark:fill-zodiac-300" rx="20" ry="7.5" />
      <ellipse cx="348.609" cy="642.5" className="fill-zodiac-500 dark:fill-zodiac-300" rx="20" ry="7.5" />
      <circle cx="318.609" cy="518" r="27" fill="#fff" />
      <circle cx="318.609" cy="518" r="9" fill="#3f3d56" />
      <path
        className="fill-ribbon-500 dark:fill-ribbon-300"
        d="M239.976 464.532c-6.378-28.567 14.012-57.434 45.544-64.474s62.266 10.41 68.644 38.977-14.518 39.104-46.05 46.145-61.759 7.92-68.138-20.648z"
      />
      <ellipse
        cx="417.215"
        cy="611.344"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="39.5"
        ry="12.4"
        transform="rotate(-23.171 156.408 637.654)"
      />
      <ellipse
        cx="269.215"
        cy="664.344"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="39.5"
        ry="12.4"
        transform="rotate(-23.171 8.408 690.654)"
      />
      <path fill="#fff" d="M362.61 561c0 7.732-19.91 23-42 23s-43-14.268-43-22 20.908-6 43-6 42-2.732 42 5z" />
    </svg>
  );
}

export function IllustrationLoading() {
  return (
    <svg viewBox="0 0 430.914 559.71">
      <path
        fill="#e5e5e5"
        d="M304.755 154.54q0 4.784-.31 9.49a143.754 143.754 0 01-13.47 52.19c-.06.14-.13.27-.19.4-.36.76-.73 1.52-1.11 2.27a142.039 142.039 0 01-7.65 13.5 144.462 144.462 0 01-118.56 66.72l1.43 82.24 18.65-9.82 3.33 6.33-21.84 11.5 2.67 152.74.03 2.04-14.42 1.21.03-.05 4.54-246.18a144.175 144.175 0 01-102-44.38c-.91-.94-1.81-1.91-2.69-2.87-.04-.04-.07-.08-.1-.11A144.768 144.768 0 0126.755 211c.14.16.29.31.43.47a144.642 144.642 0 0168.58-186.38c.5-.25 1.01-.49 1.51-.74a144.752 144.752 0 01187.53 56.93c.88 1.48 1.73 2.99 2.55 4.51a143.852 143.852 0 0117.4 68.75z"
      />
      <circle cx="198.285" cy="502.618" r="43.067" className="fill-zodiac-500 dark:fill-zodiac-300" />
      <path className="fill-zodiac-500 dark:fill-zodiac-300" d="M210.603 532.223H249.187V545.3069999999999H210.603z" />
      <ellipse cx="249.459" cy="534.403" className="fill-zodiac-500 dark:fill-zodiac-300" rx="4.089" ry="10.903" />
      <path className="fill-zodiac-500 dark:fill-zodiac-300" d="M201.603 531.223H240.187V544.3069999999999H201.603z" />
      <ellipse cx="240.459" cy="533.403" className="fill-zodiac-500 dark:fill-zodiac-300" rx="4.089" ry="10.903" />
      <path
        className="fill-ribbon-500 dark:fill-ribbon-300"
        d="M156.508 462.567c-3.477-15.574 7.639-31.31 24.829-35.149s33.944 5.675 37.421 21.25-7.915 21.317-25.104 25.155-33.668 4.318-37.146-11.256z"
      />
      <path
        fill="#fff"
        d="M214.837 500.166a10.751 10.751 0 01-10.34-7.123 1 1 0 011.897-.637c1.514 4.508 6.698 6.865 11.554 5.254a9.608 9.608 0 005.573-4.748 8.232 8.232 0 00.485-6.338 1 1 0 011.896-.637 10.217 10.217 0 01-.592 7.869 11.624 11.624 0 01-6.732 5.752 11.88 11.88 0 01-3.74.608zM234.022 506.02a9.572 9.572 0 11-17.046 8.717l-.008-.017c-2.403-4.71.917-7.632 5.627-10.035s9.024-3.375 11.427 1.334z"
      />
      <path fill="#3f3d56" d="M387.733 546.074h-381a1 1 0 010-2h381a1 1 0 010 2z" />
      <ellipse
        cx="567.226"
        cy="706.642"
        className="fill-zodiac-500 dark:fill-zodiac-300"
        rx="7.501"
        ry="23.892"
        transform="rotate(-14.461 -295.58 2137.035)"
      />
      <path
        fill="#cbcbcb"
        d="M260.966 451.278H244.58a.773.773 0 01-.519-1.345l14.9-13.495h-13.766a.773.773 0 010-1.545h15.77a.773.773 0 01.52 1.345l-14.9 13.495h14.38a.773.773 0 110 1.545zM281.83 427.323h-16.386a.773.773 0 01-.519-1.345l14.9-13.495H266.06a.773.773 0 010-1.545h15.77a.773.773 0 01.52 1.345l-14.9 13.495h14.38a.773.773 0 110 1.545zM272.557 401.05h-16.386a.773.773 0 01-.518-1.345l14.9-13.495h-13.767a.773.773 0 010-1.546h15.771a.773.773 0 01.519 1.346l-14.9 13.495h14.381a.773.773 0 010 1.545z"
      />
      <path
        fill="#3f3d56"
        d="M386.12 177.377l12.794-10.234c-9.94-1.096-14.024 4.325-15.695 8.615-7.766-3.224-16.219 1.002-16.219 1.002l25.6 9.293a19.372 19.372 0 00-6.48-8.676zM19.12 10.377L31.913.143C21.974-.953 17.89 4.468 16.219 8.758 8.453 5.534 0 9.76 0 9.76l25.6 9.293a19.372 19.372 0 00-6.48-8.676zM418.12 45.377l12.794-10.234c-9.94-1.096-14.024 4.325-15.695 8.615C407.453 40.534 399 44.76 399 44.76l25.6 9.293a19.372 19.372 0 00-6.48-8.676z"
      />
    </svg>
  );
}

export function IllustrationComingSoon() {
  return (
    <svg viewBox="0 0 786.82 572.258">
      <circle cx="458.321" cy="74.182" r="26.701" fill="#f2f2f2" />
      <path
        fill="#f2f2f2"
        d="M665.447 497.152c39.688-30.229 58.644-81.026 46.777-129.482q-.442-1.806-.934-3.604c-7.867-28.764-27.331-56.1-55.7-65.291-23.82-7.717-49.82-1.783-74.67-4.852-48.78-6.024-86.6-45.494-113.21-86.82-26.611-41.325-47.062-87.583-82.422-121.723-58.285-56.276-153.362-68.392-225.627-31.76C87.397 90.25 41.365 171.52 43.328 252.513c1.963 80.995 50.046 158.432 119.875 199.517 25.652 15.093 55.321 25.786 84.848 22.044 25.62-3.246 48.9-17.012 74.399-21.1 40.09-6.425 79.927 11.701 114.602 32.824 34.676 21.123 68.17 46.16 107.575 55.953 38.261 9.508 85.663-17.822 120.82-44.6z"
      />
      <path
        fill="#3f3d56"
        d="M608.426 55.32c-.87-.58-1.75-1.13-2.62-1.69a380.24 380.24 0 00-80.31-38.93l-6.54 90.22h-41.46V1.53c-2.61-.54-5.24-1.05-7.87-1.53v104.92h-49.27A102.27 102.27 0 01318.086 2.65c-2.64.57-5.26 1.18-7.88 1.83v100.44h-40.13l-6.23-86.03a380.858 380.858 0 00-81.94 43.53c-.44.3-.88.61-1.31.91-2.21 1.55-4.39 3.13-6.56 4.73v344.19h118.27l-2.09-28.95-11.5-158.95h231.59l-11.5 158.95-2.09 28.95h116.96V58.8q-2.61-1.77-5.25-3.48zM310.206 198.1h-33.39l-6.17-85.3h39.56zm159.42 0h-56.08v-1.69a6.18 6.18 0 00-6.19-6.18h-24.38a6.178 6.178 0 00-6.18 6.18v1.69h-58.71v-85.3h151.54zm7.87 0v-85.3h40.89l-6.17 85.3zM0 434.29a289.003 289.003 0 0028.12 28.95l730.58 1a289.003 289.003 0 0028.12-28.95z"
      />
      <path
        fill="#3f3d56"
        d="M495.43 341.591v85.704a4.122 4.122 0 004.119 4.12h127.004a4.122 4.122 0 004.12-4.12v-85.704a4.124 4.124 0 00-4.12-4.114H499.55a4.124 4.124 0 00-4.12 4.114z"
      />
      <path
        fill="#126cee"
        d="M498.41 342.658v83.58a2.205 2.205 0 002.2 2.201h124.886a2.205 2.205 0 002.202-2.2v-83.581a2.206 2.206 0 00-2.202-2.206H500.611a2.206 2.206 0 00-2.202 2.206z"
      />
      <path
        fill="#2f2e41"
        d="M492.774 444.01a2.47 2.47 0 001.943.93H630.71a2.502 2.502 0 002.446-3.016l-2.11-10.027a2.507 2.507 0 00-1.559-1.818 2.425 2.425 0 00-.888-.168H496.82a2.424 2.424 0 00-.888.168 2.507 2.507 0 00-1.558 1.818l-2.111 10.027a2.5 2.5 0 00.51 2.086z"
      />
      <rect
        width="4.188"
        height="2.513"
        x="830.034"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 728.833 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="821.657"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 720.456 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="813.28"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 712.08 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="804.903"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 703.702 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="796.526"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 695.325 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="788.149"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 686.948 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="779.772"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 678.571 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="771.395"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 670.194 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="763.018"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 661.817 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="754.641"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 653.44 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="746.264"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 645.063 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="737.887"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 636.686 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="729.51"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 628.31 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="721.133"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 619.932 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="712.756"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 611.555 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="704.379"
        y="595.588"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 603.178 514.91)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="830.133"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 728.932 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="821.756"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 720.555 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="813.379"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 712.178 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="805.002"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 703.801 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="796.625"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 695.424 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="788.248"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 687.047 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="779.871"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 678.67 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="771.494"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 670.293 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="763.117"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 661.916 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="754.74"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 653.54 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="746.363"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 645.162 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="737.986"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 636.785 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="729.609"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 628.408 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="721.232"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 620.031 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="712.855"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 611.654 519.098)"
      />
      <rect
        width="4.188"
        height="2.513"
        x="704.478"
        y="599.777"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 603.277 519.098)"
      />
      <rect
        width="33.508"
        height="2.513"
        x="760.604"
        y="604.803"
        fill="#3f3d56"
        rx="0.488"
        transform="rotate(-180 674.063 524.124)"
      />
      <rect width="5.966" height="3.122" x="515.631" y="358.737" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="548.154" y="358.737" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="557.369" y="358.737" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="524.477" y="358.477" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="567.841" y="358.477" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="524.304" y="365.784" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="556.827" y="365.784" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="566.042" y="365.784" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="533.15" y="365.523" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="576.514" y="365.523" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="532.977" y="372.83" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="565.5" y="372.83" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="574.715" y="372.83" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="541.823" y="372.57" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="585.187" y="372.57" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="541.649" y="379.877" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="574.172" y="379.877" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="583.387" y="379.877" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="550.496" y="379.617" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="548.154" y="407.898" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="557.369" y="407.898" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="567.841" y="408.158" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="515.631" y="407.898" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="524.477" y="408.158" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="524.304" y="400.851" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="556.827" y="400.851" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="566.042" y="400.851" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="533.15" y="401.111" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="532.977" y="393.804" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="565.5" y="393.804" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="574.715" y="393.804" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="541.823" y="394.064" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="541.649" y="386.758" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="574.172" y="386.758" fill="#fff" rx="1.561" />
      <rect width="5.966" height="3.122" x="583.387" y="386.758" fill="#fff" rx="1.561" />
      <rect width="20.796" height="3.122" x="550.496" y="387.018" fill="#fff" rx="1.561" />
      <path
        fill="#ffb6b6"
        d="M504.917 490.482l-13.35-21.102 41.903-33.403 17.295-19.16a19.161 19.161 0 0132.418 6.827 19.161 19.161 0 01-11.57 23.991l-27.349 10.075z"
      />
      <path
        fill="#2f2e41"
        d="M191.69 337.48v102.56h71.85V337.48a3.448 3.448 0 00-2.43-3.3 3.175 3.175 0 00-1.03-.16h-64.92a3.463 3.463 0 00-3.47 3.46zm28.04 35.24a7.67 7.67 0 0115.34 0v11.9a7.67 7.67 0 01-15.34 0z"
      />
      <path
        fill="#3f3d56"
        d="M191.47 436.76v9.89a1.946 1.946 0 001.93 1.94h68.43a1.94 1.94 0 001.93-1.94v-9.89zM78.66 182.96v187.26a9.007 9.007 0 009 9h277.5a9.007 9.007 0 009-9V182.96a9.011 9.011 0 00-9-8.99H87.66a9.012 9.012 0 00-9 8.99z"
      />
      <path
        fill="#fff"
        d="M85.17 185.29v182.62a4.818 4.818 0 004.81 4.81h272.87a4.818 4.818 0 004.81-4.81V185.29a4.82 4.82 0 00-4.81-4.82H89.98a4.82 4.82 0 00-4.81 4.82z"
      />
      <path
        fill="#2f2e41"
        d="M135.81 447.92a2.948 2.948 0 002.32 1.11h162.34a2.987 2.987 0 002.92-3.6l-2.52-11.97a2.993 2.993 0 00-1.86-2.17 2.895 2.895 0 00-1.06-.2H140.64a2.894 2.894 0 00-1.06.2 2.992 2.992 0 00-1.86 2.17l-2.52 11.97a2.985 2.985 0 00.61 2.49z"
      />
      <path fill="#3f3d56" d="M353.994 205.628H98.671a1.016 1.016 0 010-2.031h255.323a1.016 1.016 0 010 2.03z" />
      <ellipse cx="116.051" cy="192.33" fill="#3f3d56" rx="5.95" ry="6.083" />
      <ellipse cx="136.607" cy="192.33" fill="#3f3d56" rx="5.95" ry="6.083" />
      <ellipse cx="157.163" cy="192.33" fill="#3f3d56" rx="5.95" ry="6.083" />
      <path
        fill="#3f3d56"
        d="M341.616 187.75h-14.6a1.105 1.105 0 000 2.21h14.6a1.105 1.105 0 000-2.21zM341.616 191.9h-14.6a1.105 1.105 0 000 2.21h14.6a1.105 1.105 0 000-2.21zM341.616 196.05h-14.6a1.105 1.105 0 000 2.21h14.6a1.105 1.105 0 000-2.21z"
      />
      <path
        fill="#2f2e41"
        d="M693.596 441.101a6.416 6.416 0 006.183 4.331l26.492-.682a6.329 6.329 0 005.98-4.657l3.75-40.087a9.794 9.794 0 004.237.871 9.661 9.661 0 10-.485-19.317 8.184 8.184 0 00-1.736.181 6.548 6.548 0 00-4.874-2.103l-40.75 1.052a5.853 5.853 0 00-1.006.125 6.365 6.365 0 00-4.873 8.265zm43.173-43.817l2.668-9.552a6.506 6.506 0 00.02-3.375c.13 0 .244-.062.373-.062a6.91 6.91 0 01.324 13.817 6.505 6.505 0 01-3.385-.828z"
      />
      <path
        fill="#3f3d56"
        d="M691.387 380.815c.869 4.964 10.63 8.454 22.366 7.847 10.793-.497 19.618-4.287 21.235-8.778a6.025 6.025 0 00-1.845-.246l-40.75 1.052a5.853 5.853 0 00-1.006.125z"
      />
      <path
        fill="#126cee"
        d="M715.904 419.073a.497.497 0 00.151-.066l5.753-3.766a.5.5 0 000-.836l-5.98-3.917a.5.5 0 10-.547.836l5.34 3.498-5.113 3.348a.5.5 0 00.396.903zM706.818 419.492a.5.5 0 00.126-.918l-5.303-3.04 5.125-3.808a.5.5 0 10-.596-.802l-5.738 4.263a.5.5 0 00.049.834l5.965 3.42a.5.5 0 00.372.051zM715.332 422.373a.482.482 0 00.137-.058.5.5 0 00.168-.687l-8.156-13.408a.5.5 0 00-.854.52l8.155 13.409a.5.5 0 00.55.224z"
      />
      <rect width="50.719" height="10.846" x="209.385" y="260.827" fill="#126cee" rx="3.264" />
      <rect width="102.236" height="10.846" x="183.626" y="282.519" fill="#e6e6e6" rx="3.264" />
      <rect width="102.236" height="10.846" x="183.626" y="304.21" fill="#e6e6e6" rx="3.264" />
      <path
        fill="#3f3d56"
        d="M290.711 376.846l.217.684.011.023 6.526 19.838 7.506 22.861 14.122 42.961.137 6.674v.023l1.05 53.684-2.91 7.278 3.275 11.933s-1.506-18.037-9.582-7.68c-4.575 5.887-9.925 11.91-14.317 17.557q9.6 3.885 19.507 7.027c1.426.457 2.863.89 4.3 1.324l.925.273a266.863 266.863 0 0067.35 10.826c1.187.035 2.35.057 3.48.08.4.012.787.023 1.175.023 1.278.011 2.544.023 3.821.023q3.868 0 7.7-.114a266.853 266.853 0 0056.092-7.586c-.125-7.586-.468-16.45-.958-25.919-.228-4.643-5.35-9.673-5.658-14.533-.217-3.65 4.38-7.084 4.14-10.792-1.55-22.826-3.49-14.064-4.927-30.228q-.223-2.379-.411-4.552c-.924-10.381-1.563-16.872-1.563-16.872l6.137-38.683 9.64-60.735-.742-1.22-.832-.411-50.844-25.166-2.761-7.072a10.979 10.979 0 00-10.141-6.948l-33.493-.136a10.931 10.931 0 00-8.91 4.528l-9.069 12.56z"
      />
      <path
        fill="#3f3d56"
        d="M326.816 453.654l-7.586 16.233-5.179 11.088-8.909 46.646-4.46 4.734-3.822-16.76-39.998 8.882c-1.312-7.29-.351.246-1.16-7.75.227-.228.467-.457.706-.685.64-.593 1.175-1.152 1.164-1.688-.456-27.584.913-74.526 12.343-102.966a60.053 60.053 0 017.027-13.107c.228-.308.445-.616.662-.924 5.27-7.38 8.601-14.648 13.324-19.815v-.012a.53.53 0 00.08-.08.157.157 0 00.045-.034l32.444-17.203 1.392 39.106.992 28.108zM443.801 458.264l9.476 20.275 3.308 7.061 8.907 46.642 4.445 4.723 3.83-16.756 1.8-.369 32.459-6.722 9.46 30.046a17.984 17.984 0 00-3.26-22.506c-.647-.584-1.185-1.153-1.17-1.692.539-32.443-1.446-91.683-19.367-116.066-5.692-7.737-9.107-15.444-14.076-20.828-.015-.016-.015-.031-.03-.031l-12.092-19.798-.738-1.216-.83-.415z"
      />
      <circle cx="386.397" cy="267.201" r="44.558" fill="#ffb6b6" data-name="Ellipse 5" />
      <path
        fill="#2f2e41"
        d="M446.622 236.077a3.76 3.76 0 00-2.69-1.19l.67-1.86a3.528 3.528 0 00-3.96-4.7l-2.44.47.23-1.63a3.534 3.534 0 00-4.73-3.82 3.766 3.766 0 01-3.24-.23 3.846 3.846 0 01-1.92-2.61l-.85-4.1-.09-.22c-4.14-6.9-12.1-11.92-21.84-13.76-8.67-1.65-17.56-.81-26.13-.02-3.4.32-7.24.68-10.44 2.64-2.72 1.68-5.02 5.04-4.55 8.43-8.45-2.59-17.51 2.58-22 9.1-5.32 7.76-6.19 17.48-6.33 25.08-.38 17.98 3.33 32.69 11 43.73.56.8.7 2.47 1.81 3.03l-.23-.37c1.24.62 2.5 1.62 2.03 2.69-1.35 3.08 7.62 9.89 13.94 12.14 11.53 4.11 26.86 3.76 37.64 2.28l.38-2.55c3.89-.53 6.63-1.54 7.4-3.12 1.36-1.16 2.52-2.2 3.53-3.16l.01-.01c.02-.02.06-.05.08-.07 4.87-4.67 6-7.33 6.51-11.38.49-3.97-.38-8-1.27-11.63 18.74 2.9-7.38-19.96 10.08-24.38a5.434 5.434 0 01.61-.15c.51-.12 1.02-.24 1.51-.38a26.448 26.448 0 006.72-2.87c4.88-2.97 6.49-6.91 9.01-11.35a3.427 3.427 0 00-.45-4.03zM543.992 461.437c-.01 1.75-.03 4.2-.11 7.23l-.03 1.29c-.13 5.57-.26 10.24-.47 15.43-.01.36-.02.71-.04 1.07-.28 7.24-.72 15.67-1.48 29.02-1.41 24.66-3.87 3.39-6.34 12.04-.12.43-.25.94-.37 1.54a27.916 27.916 0 01-1.88 6.33c-1.31.78-2.66 1.53-3.99 2.28-3.79 2.11-7.64 4.14-11.52 6.07-2.18 1.08-4.37 2.14-6.57 3.16-.35.16-.69.32-1.03.47a270.887 270.887 0 01-34.75 13.26c-2.32.7-4.63 1.38-6.97 2.01-2.44.68-4.88 1.32-7.35 1.92a266.893 266.893 0 01-56.09 7.59c-2.55.08-5.12.11-7.7.11-1.28 0-2.54-.01-3.82-.02-.39 0-.78-.01-1.17-.02-1.13-.03-2.3-.05-3.48-.08a266.663 266.663 0 01-67.35-10.83l-.93-.27c-1.44-.44-2.87-.87-4.3-1.33q-9.9-3.135-19.51-7.02-7.335-2.955-14.5-6.34a.339.339 0 01-.12-.06c-1-.46-2.01-.94-3.01-1.43-.13-.07-.27-.14-.41-.21q-5.595-2.73-11.07-5.72c-3.07-7.05-7.39-8.4-10.07-14.6a25.874 25.874 0 01-1.68-5.74c0-.02-.01-.04-.01-.07.28 3.72-1.19-6.6-.01-.04a52.001 52.001 0 00-.16-1.75c-3.43-33.49-3.21-71.79-4.7-103.35q-.15-3.06-.31-5.86c-.03-.62-.07-1.23-.11-1.83.07-.18.15-.37.24-.55a1.002 1.002 0 01.07-.15 1.623 1.623 0 01.1-.18l.07-.1a.917.917 0 01.05-.1c.09-.14.19-.29.3-.43.05-.06.09-.11.14-.16a.808.808 0 01.12-.14.637.637 0 01.11-.13c.04-.04.08-.09.13-.14a.302.302 0 01.08-.08 2.033 2.033 0 01.26-.25 9.624 9.624 0 011.14-.9c.14-.09.29-.18.43-.28a19.135 19.135 0 013.17-1.52c.38-.14.76-.27 1.17-.41.15-.04.29-.09.44-.14.22-.07.44-.14.67-.19 1.14-.34 2.37-.63 3.7-.9.16-.03.33-.06.5-.1.24-.05.49-.09.74-.13.34-.06.69-.12 1.04-.18 2.97-.47 6.34-.82 10.06-1.05l1.05-.06 1.24-.06c.35-.02.71-.03 1.07-.04.35-.02.71-.03 1.08-.04 1.01-.03 2.05-.06 3.11-.08 3.02-.06 6.2-.04 9.54.03 1.55.04 3.13.08 4.75.15.11 0 .21.01.31.01 1.41.05 2.83.11 4.29.19 1.02.05 2.05.1 3.08.16.97.06 1.95.12 2.94.19.77.04 1.54.1 2.32.15.66.05 1.32.1 1.98.14l.9.06c.49.04.98.07 1.48.12 1.1.09 2.2.18 3.32.27 1.11.1 2.24.2 3.37.3s2.27.21 3.41.32l.34.03c1.04.11 2.08.21 3.13.32.24.02.49.04.73.07 1.001.1 2.022.218 3.032.325l.93.1c.791.087 1.571.161 2.368.255 1.05.12 2.12.23 3.16.37.81.09 1.62.18 2.43.28 1.27.15 2.56.31 3.85.48.49.06.98.12 1.47.19 3.68.46 7.4.97 11.18 1.5 5.73.81 11.55 1.69 17.41 2.64q8.805 1.425 17.71 3.01c1.5.27 3 .54 4.51.82l2.04.39c1.16.21 2.32.43 3.48.65 1.16.22 2.32.44 3.48.67l4.15.81c9.09 1.8 18.13 3.72 26.95 5.73 1.45.33 2.9.67 4.34 1q4.32 1.005 8.56 2.04c.78.18 1.55.37 2.32.56 1.92.48 3.84.96 5.73 1.45l.33.09c1.39.34 2.75.69 4.11 1.05q4.815 1.26 9.47 2.55 3.09.855 6.11 1.73c3.01.87 5.96 1.75 8.83 2.64.71.22 1.42.44 2.12.65 2.1.65 4.17 1.31 6.18 1.97 1.6.52 3.16 1.05 4.7 1.58q2.31.795 4.53 1.59c.95.34 1.89.7 2.83 1.04 1.35.5 2.68 1 3.98 1.5.4.15.79.31 1.18.46.25.11.49.2.73.3.47.19.95.37 1.41.56.47.18.93.37 1.39.57.45.18.91.37 1.35.56.45.18.89.37 1.33.57.37.15.73.31 1.08.47.71.31 1.42.62 2.11.94.34.16.68.31 1.02.47l.78.36c.11.06.22.11.33.16.25.12.51.25.76.37.58.27 1.15.56 1.71.83.75.38 1.48.76 2.18 1.13.71.38 1.4.76 2.06 1.13.11.06.21.12.32.18.15.08.3.17.45.25.51.29 1 .59 1.49.88.96.59 1.87 1.17 2.72 1.75.19.13.37.26.56.38.63.45 1.23.89 1.79 1.34 0 .01 0 .01.01.01.19.14.37.29.55.43.15.14.31.26.46.4.52.45 1 .88 1.44 1.32a5.667 5.667 0 01.42.43 1.208 1.208 0 01.16.16c.2.2.38.4.55.6a.553.553 0 01.07.09c.24.28.46.56.67.84.1.14.21.28.3.42.12.17.24.35.34.52.09.14.17.29.25.43a7.257 7.257 0 01.54 1.13 5.241 5.241 0 01.27.82 5.844 5.844 0 01.17.81z"
      />
      <path
        d="M543.992 461.437c-.01 1.75-.03 4.2-.11 7.23-.01.42-.03.85-.04 1.29-.1 4.25-.25 9.5-.46 15.43-.01.36-.02.71-.04 1.07-.28 7.24-.72 15.67-1.48 29.02-1.41 24.66-3.87 3.39-6.34 12.04-6.86-4.22-14.38-8.64-22.42-13.18q-2.175-1.23-4.39-2.47c-16.08-8.97-34.04-18.37-52.79-27.68-.74-.37-1.49-.74-2.23-1.1-42.95-21.23-89.83-41.88-127.81-55.66-7.33-2.66-14.33-5.06-20.91-7.17-13.86-4.43-25.84-7.53-35.06-8.87-9.6-1.4-16.23-.9-18.91 1.99q-.15-3.06-.31-5.86l-.12-1.83c.062-.165.142-.322.22-.48.01-.024.019-.047.03-.07a1.002 1.002 0 01.07-.15 1.623 1.623 0 01.1-.18 1.06 1.06 0 01.12-.2c.09-.14.19-.29.3-.43a3.483 3.483 0 01.26-.3.637.637 0 01.11-.13c.04-.04.08-.09.13-.14a.302.302 0 01.08-.08 2.033 2.033 0 01.26-.25 9.624 9.624 0 011.14-.9c.14-.09.29-.18.43-.28a19.135 19.135 0 013.17-1.52c.38-.14.76-.27 1.17-.41.15-.04.29-.09.44-.14.22-.07.44-.14.67-.19 1.14-.34 2.37-.63 3.7-.9.4-.08.82-.16 1.24-.23.34-.06.69-.12 1.04-.18 2.97-.47 6.34-.82 10.06-1.05l1.05-.06 1.24-.06c.35-.02.71-.03 1.07-.04.35-.02.71-.03 1.08-.04 1.01-.03 2.05-.06 3.11-.08 3.02-.05 6.2-.03 9.54.04 1.55.03 3.13.08 4.75.15.1 0 .21.01.31.01 1.41.04 2.84.11 4.29.18 1.02.05 2.05.1 3.08.16.97.06 1.95.12 2.94.19.77.04 1.54.1 2.32.15.66.05 1.32.1 1.98.14l2.38.18c1.1.09 2.2.18 3.32.27 1.11.1 2.24.2 3.37.3s2.27.21 3.41.32l.34.03c1.04.11 2.08.21 3.13.32q8.73.885 17.97 2.07 5.52.705 11.18 1.51c5.73.81 11.55 1.69 17.41 2.63q8.805 1.425 17.71 3.01c1.5.27 3 .54 4.51.82q2.76.51 5.52 1.04c1.16.22 2.32.44 3.48.67l4.15.81c9.09 1.8 18.13 3.72 26.95 5.73 1.45.33 2.9.67 4.34 1q4.32 1.005 8.56 2.04c.78.19 1.55.38 2.32.57q2.895.72 5.73 1.44v.01c.11.02.22.05.33.08 1.38.35 2.75.7 4.11 1.06q4.815 1.26 9.47 2.54c2.06.58 4.1 1.15 6.11 1.73a705.922 705.922 0 0110.95 3.29q3.15.99 6.18 1.97c1.6.52 3.16 1.05 4.7 1.58q2.31.795 4.53 1.59c.96.34 1.9.69 2.83 1.03 1.36.5 2.68 1 3.98 1.51.4.15.79.31 1.18.46.73.28 1.44.57 2.14.86.47.18.93.37 1.39.57.45.18.91.37 1.35.56.45.18.89.37 1.33.57.37.15.73.31 1.08.47.71.31 1.42.62 2.11.94.34.16.68.31 1.02.47l.78.36c.11.06.22.11.33.16.85.4 1.67.8 2.47 1.2.75.38 1.48.76 2.18 1.13.83.44 1.62.87 2.38 1.31.15.08.3.17.45.25.51.29 1 .59 1.49.88.96.59 1.87 1.17 2.72 1.75.84.58 1.62 1.15 2.35 1.72 0 .01 0 .01.01.01.35.28.69.56 1.01.83.52.45 1 .88 1.44 1.32a5.667 5.667 0 01.42.43 1.208 1.208 0 01.16.16c.21.23.42.46.62.69.24.28.46.56.67.84.1.14.21.28.3.42.12.17.24.35.34.52.09.14.17.29.25.43a7.257 7.257 0 01.54 1.13 6.053 6.053 0 01.27.82 5.844 5.844 0 01.17.81z"
        opacity="0.2"
      />
    </svg>
  );
}
